import { forwardRef, useState } from 'react';
import styled from '@emotion/styled';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

dayjs.extend(utc);
dayjs.extend(timezone);

type Props = {
    value: string;
    format?: string;
    error?: string;
    inputStyle?: React.CSSProperties;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const Wrapper = styled.div`
    position: relative;
    display: inline-block;
    width: 100%;

    .MuiFormControl-root {
        width: 100%;
    }
`;

export const DatePicker = forwardRef<HTMLInputElement, Props>(({ value, format, onChange, ...props }, ref) => {
    const dateTimeFormat = format ?? 'YYYY/MM/DD HH:mm';
    const [open, setOpen] = useState(false);
    const date = value ? dayjs(value, 'YYYY/MM/DD HH:mm').tz('Asia/Tokyo', true) : null;

    const handleChange = (newValue: dayjs.Dayjs | null) => {
        if (newValue) {
            // JST をそのまま保持してフォーマット
            const jstValue = newValue.format('YYYY/MM/DD HH:mm');
            const event = { target: { value: jstValue } } as React.ChangeEvent<HTMLInputElement>;
            onChange?.(event);
        }
    };

    return (
        <Wrapper>
            <DateTimePicker
                value={date}
                onChange={handleChange}
                format={dateTimeFormat}
                ampm={false}
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                slotProps={{
                    popper: { sx: { zIndex: 4000 } },
                    dialog: { sx: { zIndex: 4000 } },
                    textField: { inputRef: ref, style: props.inputStyle },
                }}
            />
        </Wrapper>
    );
});

DatePicker.displayName = 'DatePicker';
